// Must be int, because it's ordered
export class TireAvailabilityType {
    static AVAILABLE = 1;               //
    static NON_AVAILABLE_STORE = 2;     // These tires are stored in an other location
    static NON_AVAILABLE_TYPE = 3;      // This tire type is not managed in this location
}

Object.freeze(TireAvailabilityType);